import { type FC, type ReactNode } from 'react';

import { Footer } from './styles';

const ProjectFooter: FC<{ children: ReactNode }> = ({ children }) => <Footer gap={2}>{children}</Footer>;

export default ProjectFooter;
